function applySelectedHandler() {

}
export default applySelectedHandler;